import styled from "styled-components";

export const AddressInfoStyled = styled.div`
  .address_title {
    margin-bottom: 15px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: 14px;
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .address_detail {
    margin-bottom: 15px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: 14px;
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .address_map {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: 14px;
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    text-decoration: none;
  }
`;
